import { useEffect, useMemo, useState } from 'react';
import styles from './detail.module.scss';
import { MyPublicationDetailProps } from '../../../../interfaces/pages';
import ButtonShared from '../../../../components/Button/Button';
import PublicationDetailRefactored from '../../../../components/PublicationDetail/PublicationDetailRefactored';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../../helpers/hooks';
import ProfileCard from '../../../../components/ProfileCard/ProfileCard';
import { myPubDetailBreadCrumb } from '../../../../constants/breadCrumbs';
import { useWindowSize } from "use-hooks";
import { capitalize } from '../../../../helpers/app';
import { caracteristics, conforts } from '../../../../constants/images';

const Detail = ({
    user,
    getPublication,
    getArticlesFromPublication,
    publication,
    cleanAllPublication
}: MyPublicationDetailProps) => {
    const params = useParams();
    const toast = useToast();
    const navigate = useNavigate();
    const windowSize = useWindowSize();
    const [publicationAux, setPublicationAux] = useState<any>({});

    const handlePressManagement = () => {
        cleanAllPublication();
        navigate(`/perfil/mis_publicaciones/${publication?.data?.id_publication}/gestion`);
    }

    const handlePressEdit = () => {
        navigate(`/perfil/mis_publicaciones/${publication?.data?.id_publication}/editar`);
    }

    const publicationNormalized: any = useMemo(() => {
        const publicationObject = {
            id: publicationAux?.data?._id,
            pictures: publicationAux?.data?.pictures,
            condition: publicationAux?.data?.condition,
            title: publicationAux?.data?.title,
            year: publicationAux?.data?.primary_description,
            mileage: publicationAux?.data?.secondary_description,
            region: publicationAux?.data?.region,
            branch_data:publicationAux?.data?.branch_data,
            price: publicationAux?.data?.price,
            sale_price: publicationAux?.data?.other_prices?.sale_price,
            liked: publicationAux?.data?.liked,
            chatgpt_description: publicationAux?.data?.chatgpt_description_summary,
            tags: publicationAux?.data?.tags,
            vehicle_data: publicationAux?.data?.vehicle_data,
            user_description: publicationAux?.data?.user_description,
            version: publicationAux?.data?.vehicle_data?.version,
            certified: publicationAux?.data?.certified,
            paused: publicationAux?.data?.paused,
            suggested_prices:  publicationAux.articles?.data.suggested_price,
            additional_characters: publicationAux?.articles?.data?.additional_characters,
            detail: publicationAux?.data?.record ? publicationAux?.data?.detail.concat(publicationAux?.data?.record) : publicationAux?.data?.detail,
            caracteristics: [
                {
                    name: "Modelo",
                    value: publicationAux?.data?.vehicle_data?.model,
                    icon: caracteristics.model
                },
                {
                    name: "Año",
                    value: publicationAux?.data?.primary_description,
                    icon: caracteristics.year
                },
                {
                    name: "Versión",
                    value: (publicationAux?.articles?.data?.version_id !== 0 && publicationAux?.articles?.data?.version_id !== 1) ? capitalize(publicationAux?.articles?.data?.version) : null,
                    icon: caracteristics.version
                },
                {
                    name: "Color",
                    value: capitalize(publicationAux?.articles?.data?.color),
                    icon: caracteristics.color
                },
                {
                    name: "Tipo de combustible",
                    value: capitalize(publicationAux?.articles?.data?.fuel),
                    icon: caracteristics.fuel
                },
                {
                    name: "Puertas",
                    value: publicationAux?.articles?.data?.doors,
                    icon: caracteristics.door
                },
                {
                    name: "Transmisión",
                    value: capitalize(publicationAux?.articles?.data?.transmission),
                    icon: caracteristics.transmission
                },
                {
                    name: "Tipo de carrocería",
                    value: capitalize(publicationAux?.articles?.data?.type),
                    icon: caracteristics.type
                }
            ],
            confort: [
                {
                    name: "Sistema de audio Hi-Fi",
                    value: publicationAux?.articles?.data?.confort?.audio_hifi ? "Si" : "No",
                    icon: conforts.audio_hifi
                },
                {
                    name: "Asientos de cuero",
                    value: publicationAux?.articles?.data?.confort?.leather_seats ? "Si" : "No",
                    icon: conforts.leather_seats
                },
                {
                    name: "Climatizador automático",
                    value: publicationAux?.articles?.data?.confort?.air_filter ? "Si" : "No",
                    icon: conforts.air_filter
                },
                {
                    name: "Computadora a bordo",
                    value: publicationAux?.articles?.data?.confort?.on_board_computer ? "Si" : "No",
                    icon: conforts.on_board_computer
                },
                {
                    name: "Velocidad crucero",
                    value: publicationAux?.articles?.data?.confort?.cruice_speed ? "Si" : "No",
                    icon: conforts.cruice_speed
                },
                {
                    name: "Sensor de estacionamiento",
                    value: publicationAux?.articles?.data?.confort?.parking_sensor ? "Si" : "No",
                    icon: conforts.parking_sensor
                },
                {
                    name: "Conectividad BT / Wifi",
                    value: publicationAux?.articles?.data?.confort?.bt_wifi ? "Si" : "No",
                    icon: conforts.bt_wifi
                },
                {
                    name: "Cristales eléctricos",
                    value: publicationAux?.articles?.data?.confort?.electric_crystals ? "Si" : "No",
                    icon: conforts.electric_crystals
                }
            ]
        }
        return publicationObject;
    }, [publicationAux]);

    useEffect(() => {
        if (publication?.fetching === "failure" || publication?.articles?.fetching === "failure") {
            cleanAllPublication();
            if (publication?.error === "ID_INVALID_FORMAT" || publication?.articles?.error === "ID_INVALID_FORMAT") {
                return navigate("/perfil/publicaciones");
            }
            toast("Ha ocurrido un error para mostrar la publicación");
        }
        if (publication?.fetching === "success" && publication?.articles?.fetching === "success") {
            setPublicationAux(publication);
        }
    }, [publication?.fetching, publication?.articles?.fetching]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (params.id) {
            getArticlesFromPublication(params?.id);
            getPublication(params?.id);
        } else {
            navigate("/");
        }
    }, [params.id]);
    
    return(
        <ProfileCard className={styles.myPublicationDetailContainer} breadCrumbs={myPubDetailBreadCrumb(`${publicationNormalized?.title}`)}>
            <PublicationDetailRefactored 
                type="myPublication"
                logoDealerships={publicationAux?.data?.branch_data?.picture}
                publication={publicationNormalized}
                loading={publication?.fetching === "loading" || publication?.articles?.fetching === "loading"}
            >
                {
                    <div className={styles.children}>
                        <ButtonShared
                            onPress={handlePressManagement}
                            title="Gestión"
                            tertiary
                            className={styles.management}
                            id="managementPublicationButton"
                            size={window.innerWidth > 780 ? "small" : "normal"}
                        />
                        <ButtonShared
                            onPress={handlePressEdit}
                            title="Editar"
                            primary
                            disabled={publication?.data?.paused || !["published","rejected"].includes(publication?.data?.status_brief?.code)}
                            className={styles.edit}
                            size={window.innerWidth > 780 ? "small" : "normal"}
                        />
                    </div>
                }
            </PublicationDetailRefactored>
        </ProfileCard>
    )
}

export default Detail;